import { render, staticRenderFns } from "./NewsImageListing.vue?vue&type=template&id=5b65655b&scoped=true&"
import script from "./NewsImageListing.vue?vue&type=script&lang=js&"
export * from "./NewsImageListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65655b",
  null
  
)

export default component.exports